import { BlogResource } from './BlogResource';

export class BlogListResource {
    blogList: BlogResource[];
    errorCode: number;
	errorMessage: string;
}